import { Graphics } from "pixi.js";
import DisplayContainerOptions from "../interfaces/DisplayContainerOptions";
import AppModel from "../models/AppModel";
import { AssessmentPart, AssessmentQuestion } from "../models/AssessmentData";
import ActivityContainer from "../components/ActivityContainer";
import TextButton from "../components/TextButton";

export default class MultipleChoice extends ActivityContainer {

    private bg: Graphics;
    private model: AppModel;

    private data: AssessmentPart;
    private questions: AssessmentQuestion[];
    private incorrectCount: number;
    private discontinuationCount: number;
    private currentQuestion: AssessmentQuestion;
    private correctBtn: TextButton;

    constructor(/*readyFunction: Function, */part: AssessmentPart, completeFunction: Function, options?: DisplayContainerOptions) {
        super(completeFunction);
        //this.readyFunction = readyFunction;
        this.data = part;
        if (options) {
            this.options = options;
        }
        else {
            this.setDefaultOptions();
        }
        this._init();
    }

    private _init() {
        this.label = "Menu";
        this.model = AppModel.getInstance();
        this.discontinuationCount = this.data.discontinuationCount;
        this.setupQuestions();
        if (this.options.autoCreate) {
            this.create(this.options.showAfterCreate);
        }
    }

    private createButtons(): void {
        const numAnswers = this.currentQuestion.answers.length;
        for (let i = 0; i < numAnswers; i++) {
            const curAnswer = this.currentQuestion.answers[i];
            const button = new TextButton(curAnswer.answer);
            console.log(this.model.centerX);
            button.x = 363 + (i * 220);
            button.y = this.model.centerY - 100;
            button.onpointertap = this.handleBtnTap;
            if (curAnswer.correct === true) {
                this.correctBtn = button;
            }
            this.addChild(button);
            button.create();
        }
    }

    private handleBtnTap = async (event): Promise<void> => {
        let correct: boolean = true;
        if (event.currentTarget !== this.correctBtn) {
            this.incorrectCount++;
            correct = false;
        }
        await this.saveAnswer(correct, event.currentTarget.text);

        this.playNext();
    }

    private playNext(): void {
        this.removeChildren();
        this.currentQuestion = this.questions.shift();
        if (this.currentQuestion !== undefined) {
            this.createButtons();
        } else {
            this.endEarly = this.incorrectCount >= this.data.discontinuationCount;
            this.activityComplete();
        }
    }

    private async saveAnswer(correct: boolean, answered: string): Promise<void> {
        await fetch(`/Speech/saveAnswer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId: this.model.userId, questionId: this.currentQuestion.id, correct: correct, answered: answered })
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Error saving answer: ${response.status}`)
            }
        }).catch(e => {
            console.error(e);
            debugger;
        });
    }

    private setDefaultOptions(): void {
        this.options = {
            autoCreate: true,
            showAfterCreate: true
        };
    }

    private setupQuestions(): void {
        this.incorrectCount = 0;
        this.questions = [];
        const numQuestions = this.data.questions.length;
        for (let i = 0; i < numQuestions; i++) {
            const curQuestion = this.data.questions[i];
            if (curQuestion.isComplete === false) {
                this.questions.push(curQuestion);
            } else if (curQuestion.correct === false) {
                this.incorrectCount++;
            }
        }
    }

    //----------------------------------
    //  Public:
    //----------------------------------

    public override create(showAfterCreate: boolean = true): void {
        //if (showAfterCreate) {
            this.show();
        //}
        this.playNext();
    }

    public override destroy(): void {
        super.destroy();
    }
}